import { formatPrice } from 'lib/utils/helpers';
import { formatPriceByStoreLocale } from 'lib/shopify';
import cn from 'classnames';
import { useGlobalModules } from 'contexts';
import styles from './unitPrice.module.scss';

const UnitPrice = ({ unitPrice, locale, className, size, price }) => {
  const { amount, referenceUnit, referenceValue } = unitPrice || {};
  const globalModules = useGlobalModules();
  const { translations, settings } = globalModules || {};

  const getFormattedUnitPrice = () => {
    if (!amount && !price) return '';

    const money = formatPriceByStoreLocale({
      locale,
      price: formatPrice(amount || price),
    });

    const formatted = `${money}/${referenceValue || 1}${
      referenceUnit || ` ${translations.label.unitPriceStackText}`
    }`;

    const displaySize = size || null;

    if (displaySize) {
      return `${displaySize} (${formatted})`;
    }

    return formatted;
  };

  if (!settings.locale?.hasUnitPrice) return null;

  return <span className={cn(styles.unitPrice, className)}>{getFormattedUnitPrice()}</span>;
};

export default UnitPrice;
